import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import "../../styles/Auth/store.css";

const sanitizeValue = (val, isMulti) => {
    if (isMulti) {
        if (!Array.isArray(val)) return [];
        return val.filter(
            (v) =>
                v &&
                typeof v === "object" &&
                v.value !== undefined &&
                v.label !== undefined
        );
    } else {
        if (Array.isArray(val)) return val[0] || null;
        if (val && typeof val === "object" && val.value !== undefined) return val;
        return null;
    }
};

const ServiceCategorySelect = ({
    value,
    onChange,
    loadServiceCategories,
    isMulti = false,
    placeholder = "Select Service Category",
    onAddServiceCategory,
    loggedInRole,
    cacheUniqs = []
}) => {
    const safeValue = useMemo(() => sanitizeValue(value, isMulti), [value, isMulti]);

    return (
        <AsyncPaginate
            isMulti={isMulti}
            value={safeValue}
            cacheUniqs={cacheUniqs}
            loadOptionsOnMenuOpen={true}
            debounceTimeout={0}
            cacheOptions={false}
            loadOptions={async (search, loadedOptions, additional) => {
                const res = await loadServiceCategories(search, loadedOptions, additional);
                let options = res?.options || [];

                if (onAddServiceCategory && additional.page === 1) {
                    options.unshift({
                        value: "__ADD_SERVICE_CATEGORY__",
                        label: "+ Add Service Category",
                        style: { color: 'blue', fontWeight: 'bold' } // Optional: make it stand out
                    });
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                const selected = sanitizeValue(val, isMulti);
                if (isMulti) {
                    if (selected?.some(v => v.value === "__ADD_SERVICE_CATEGORY__")) {
                        if (onAddServiceCategory) onAddServiceCategory();
                        return;
                    }
                } else {
                    if (selected?.value === "__ADD_SERVICE_CATEGORY__") {
                        if (onAddServiceCategory) onAddServiceCategory();
                        return;
                    }
                }
                onChange(selected);
            }}
            placeholder={placeholder}
            additional={{ page: 1 }}
            menuPortalTarget={document.body}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                })
            }}
        />
    );
};

export default ServiceCategorySelect;
